import React, {useEffect, useState, useMemo, useCallback} from 'react';
import { IonContent, IonHeader, IonPage, IonLabel, IonList, IonItem, IonSelect, 
         IonSelectOption, IonInput, IonButton, IonToggle, IonLoading, IonAlert, 
         IonIcon, IonModal, IonRadioGroup, IonCheckbox, IonDatetime } from '@ionic/react';
import HeaderApp from '../components/HeaderApp';
import { RouteComponentProps } from 'react-router-dom';
import './css/common.css';
import { ActivityTypes, EnumTimePeriods } from '../domain/enums';
import { IActivityLogSearchResult, ILogSearch_Response } from '../domain/ActivityLog';
import { IPersonInfo } from '../domain/Person';
import { IUserInfo } from '../domain/User';
import { Plugins } from '@capacitor/core';

import { DataAccessService } from '../services/dataAccessService';
import { personOutline, closeOutline, calendarOutline } from 'ionicons/icons';
import { formatDateTimeForSave } from '../services/utils';

const { Network } = Plugins;

const Search: React.FC<RouteComponentProps> = ({history, location, match}) => {
  let _format24 = "0";
  const defaultHarborID =  window.localStorage.getItem("defaultClient");
  if (window.localStorage.getItem("format24"))
      _format24 = String(window.localStorage.getItem("format24"));

  const [harbor, setHarbor] = useState(defaultHarborID ? String(defaultHarborID) : "-1");
  const [staffPerson] = useState('');
  const [timePeriod, setTimePeriod] = useState(4);
  const [searchText, setSearchText] = useState('');
  const [activityTypeId, setActivityTypeId] = useState(0);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const [harborIsVisible] = useState<boolean>(!(defaultHarborID && String(defaultHarborID) !== "-1"));
  const [pinned, setPinned] = useState(false);
  const [status, setStatus] = useState('-1');
  const [harbours, setHarbours] = useState({});
  const [showLoading, setShowLoading] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [showMessageAll, setShowMessageAll] = useState(false);
  const [pinValue, setPinValue] = useState(0);
  const [recentValue, setRecentValue] = useState(0);

  const [personId, setPersonId] = useState<number>(0);
  const [searchPerson, setSearchPerson] = useState('');
  const [selectedPersonName, setSelectedPersonName] = useState('');
  const [personSelectionVisibility, setPersonSelectionVisibility] = useState<boolean>(false);

  const [userId, setUserId] = useState('');
  const [searchUser, setSearchUser] = useState('');
  const [selectedUserName, setSelectedUserName] = useState('');
  const [userSelectionVisibility, setUserSelectionVisibility] = useState<boolean>(false);

  const [isOnline, setIsOnline] = useState<boolean>(window.localStorage.getItem("online") !== "0");
  const [displayFormat] = useState((_format24 === "0") ? "MMM DD YYYY hh:mm a" : "MMM DD YYYY HH:mm");
  const [pickerFormat] = useState((_format24 === "0") ? "MMM DD YYYY hh mm a" : "MMM DD YYYY HH mm");

  useEffect(() => {
    Network.addListener("networkStatusChange", status => {
      setIsOnline(status.connected);
      if (status.connected)
        window.localStorage.setItem("online", "1");
      else
        window.localStorage.setItem("online", "0");
    });

    return () => Network.removeAllListeners(); 
  }, [])

  useEffect(() => {
    let _pinValue = window.localStorage.getItem("pinValue");
    if (_pinValue) {
      setPinValue(Number(_pinValue));
    }
    else {
        //to be considered if possible
    }

    let _recentValue = window.localStorage.getItem("recentValue");
    if (_recentValue) {
      setRecentValue(Number(_recentValue));
    }
    else {
        //to be considered if possible
    }
    
    let clients = JSON.parse(String(window.localStorage.getItem("clients")));
    //setHarborIsVisible(clients.length > 1);
    
    if (clients) {
      let clientList: any[] = [];
      let clientListSorted = clients
           .sort((a:any,b:any) => { if (a.ClientName < b.ClientName) return -1;
                                    if (a.ClientName > b.ClientName) return 1;
                                    return 0;
                                  });
      clientList = clientListSorted.map((client:any) => ({ 
              id: client.ClientID.toString(), 
              name: client.ClientName     
            }));
      setHarbours(clientList);
    }

    let lSearchText = window.localStorage.getItem("searchText");
    if (lSearchText) {
        setSearchText(lSearchText);
    }

    FixSelectedPersonName(personId);
    FixSelectedUserName(userId);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[isOnline]);

  //#region "Persons logic"
  const personList = useMemo(() => {
    let list: IPersonInfo[] = [];
    let listToReturn: IPersonInfo[] = [];
    if (window.localStorage.getItem("persons")) {
        list = JSON.parse(String(window.localStorage.getItem("persons"))) as IPersonInfo[]; 
    }
    listToReturn = list.filter((x) => x.FirstName || x.LastName);
    if (harbor !== '-1') {
        listToReturn = list.filter((x) => x.ClientID.toString() === harbor && (x.FirstName || x.LastName))
    }
    return listToReturn;

  },[harbor]);
  
  const pickPerson = () => {
    setPersonSelectionVisibility(true);
  };

  const searchPersonList  = useMemo(() => {
    if (personId === 0) { 
      return personList
            .filter((x) => { return (x.FirstName + ' ' + x.LastName).toLowerCase().indexOf(searchPerson.toLowerCase()) > -1; })
            .map((x) => {
                return { FullName: x.FirstName + ' ' + x.LastName, Id: x.PersonID };})
            .slice(0, 6);
    }
    else {
      let listToReturn = personList
            .filter((x) => { return x.PersonID === personId })
            .map((x) => {
                return { FullName: x.FirstName + ' ' + x.LastName, Id: x.PersonID };});

      let numberToBeReturned:number = 7;             
      let remainedList = personList
            .filter((x) => { return x.PersonID !== personId
                                && (x.FirstName + ' ' + x.LastName).toLowerCase().indexOf(searchPerson.toLowerCase()) > -1 })
            .map((x) => {
                return { FullName: x.FirstName + ' ' + x.LastName, Id: x.PersonID };})
            .slice(0, numberToBeReturned);

      remainedList.forEach(element => {
            listToReturn.push(element);
      });
      return listToReturn;
    }
  },[searchPerson, personList, personId]);

  const closeSearchPerson = () => {
    FixSelectedPersonName(personId);
    setSearchPerson('');
    setPersonSelectionVisibility(false);
  }

  const FixSelectedPersonName = (_personId : number) => {
    let _selectedPersonName = '';
    if (_personId === 0)
        _selectedPersonName = 'All persons';
    else {
        let _person = personList.find((x) => x.PersonID?.toString() === _personId.toString());
        _selectedPersonName = _person?.FirstName + ' ' +_person?.LastName;
    }
    setSelectedPersonName(_selectedPersonName);
  }

  const personSelect = (e:any) => {
    let _value = Number(e.detail.value);
    setSearchPerson('');
    if (e.detail.checked) {
      setPersonId(_value);
      FixSelectedPersonName(_value);
      setPersonSelectionVisibility(false);
    }
    else
    {
      setPersonId(0);
    }
  }
//#endregion "Persons Logic"

  //#region "Users logic"
  const userList = useMemo(() => {
    let list: IUserInfo[] = [];
    let listToReturn: IUserInfo[] = [];
    if (window.localStorage.getItem("users")) {
        list = JSON.parse(String(window.localStorage.getItem("users"))) as IUserInfo[]; 
    }
    listToReturn = list.filter((x) => x.DisplayName);
    if (harbor !== '-1') {
        listToReturn = list.filter((x) => x.ClientID.toString() === harbor && x.DisplayName)
    }
    return listToReturn;

  },[harbor]);

  const pickUser= () => {
    setUserSelectionVisibility(true);
  };

  const searchUserList  = useMemo(() => {
    if (userId === '') { 
      return userList
            .filter((x) => { return (x.DisplayName).toLowerCase().indexOf(searchUser.toLowerCase()) > -1; })
            .map((x) => {
                return { FullName: x.DisplayName, Id: x.UserID };})
            .slice(0, 6);
    }
    else {
      let listToReturn = userList
            .filter((x) => { return x.UserID === userId })
            .map((x) => {
                return { FullName: x.DisplayName, Id: x.UserID };});

      let numberToBeReturned:number = 7;             
      let remainedList = userList
            .filter((x) => { return x.UserID !== userId
                                && (x.DisplayName).toLowerCase().indexOf(searchUser.toLowerCase()) > -1 })
            .map((x) => {
                return { FullName: x.DisplayName, Id: x.UserID };})
            .slice(0, numberToBeReturned);

      remainedList.forEach(element => {
            listToReturn.push(element);
      });
      return listToReturn;
    }
  },[searchUser, userList, userId]);

  const closeSearchUser = () => {
    FixSelectedUserName(userId);
    setSearchUser('');
    setUserSelectionVisibility(false);
  }

  const FixSelectedUserName = (_userId : string) => {
    let _selectedUserName = '';
    if (_userId === '')
        _selectedUserName = 'All staff persons';
    else {
        let _user = userList.find((x) => x.UserID === _userId);
        _selectedUserName = (_user) ? _user.DisplayName : '';
    }
    setSelectedUserName(_selectedUserName);
  }

  const userSelect = (e:any) => {
    let _value = e.detail.value;
    setSearchUser('');
    if (e.detail.checked) {
      setUserId(_value);
      FixSelectedUserName(_value);
      setUserSelectionVisibility(false);
    }
    else
    {
      setUserId('');
    }
  }
  //#endregion "Users Logic"

  const startDateChange = useCallback((ev :any) => {
    let _val = ev.detail.value;
    let _formattedValue = '';
    let indexGMT = _val.indexOf('GMT');
    if (indexGMT > -1) {
        _formattedValue = _val.substring(0, indexGMT);
        if (_formattedValue.indexOf("Invalid") === -1) 
            setStartDate(_formattedValue);
    } else {
        let indexT = _val.indexOf('T');
        if (indexT > -1) {
            _formattedValue = _val.substring(0, indexT+6);
            if (_formattedValue.indexOf("Invalid") === -1) 
                setStartDate(_formattedValue);
        }
    }
  },[]);

  const endDateChange = useCallback((ev :any) => {
    let _val = ev.detail.value;
    let _formattedValue = '';
    let indexGMT = _val.indexOf('GMT');
    if (indexGMT > -1) {
        _formattedValue = _val.substring(0, indexGMT);
        if (_formattedValue.indexOf("Invalid") === -1) 
            setEndDate(_formattedValue);
    } else {
        let indexT = _val.indexOf('T');
        if (indexT > -1) {
            _formattedValue = _val.substring(0, indexT+6);
            if (_formattedValue.indexOf("Invalid") === -1) 
                setEndDate(_formattedValue);
        }
    }
  },[]);

  const search = () => {
      if (activityTypeId === 0 && personId === 0 && timePeriod === 4 && !pinned && 
          searchText === "" && status === "-1" && userId === "") {
        setShowMessageAll(true);
        return;
      }

      setShowLoading(true);
      let l_staffPerson = "null";
      if (userId !== '') 
        l_staffPerson = userId;

      let l_status:boolean = false;
      if (status === "1")
        l_status = true;

      let l_person:string ='';  
      if (personId !== 0) 
        l_person =  personId.toString();

      let l_startDate:string = '';
      if (timePeriod.toString() === "5" && startDate !== '') {
          if (startDate.indexOf('GMT') > -1 || startDate.indexOf('T') === -1) {
              let changedStartDate = formatDateTimeForSave(startDate);
              l_startDate = changedStartDate;
          }
          else
            l_startDate = startDate;
      }

      let l_endDate:string = '';
      if (timePeriod.toString() === "5" && endDate !== '') {
          if (endDate.indexOf('GMT') > -1 || endDate.indexOf('T') === -1) {
              let changedEndDate = formatDateTimeForSave(endDate);
              l_endDate = changedEndDate;
          }
          else
            l_endDate = endDate;
      }

      let _token = window.localStorage.getItem("token");
      if (_token && isOnline) {
        new DataAccessService().getActivityLogList(_token, harbor, timePeriod.toString(), l_startDate, l_endDate, l_staffPerson, 
                searchText, activityTypeId, pinned, l_person, l_status)
          .then(
            function (expectedData) {
              if (expectedData) {
                let activityLogList = (JSON.parse(expectedData.toString()) as ILogSearch_Response).Results as IActivityLogSearchResult[];
               
                if (activityLogList.length > 0) {
                  let activityLogListSorted = activityLogList.sort((a:IActivityLogSearchResult, b:IActivityLogSearchResult) => {
                      if (a.DateStarting < b.DateStarting) return 1;
                      if (a.DateStarting > b.DateStarting) return -1;
                      return 0;
                  });
                  window.localStorage.setItem("activityLogList", JSON.stringify(activityLogListSorted));
                  window.localStorage.setItem("person", staffPerson);
                  window.localStorage.setItem("clientID", harbor);
                  window.localStorage.setItem("searchText", searchText);
                  window.localStorage.setItem("timePeriod", timePeriod.toString());
                  setShowLoading(false);
                  history.push('/results');
                }
                else {
                  setShowLoading(false);
                  setShowMessage(true);
                }
              }
              else {
                setShowLoading(false);
                setShowMessage(true);
              }
            },
            function (response) {
              setShowLoading(false);
              //_mythis.showPopup("Unable to perform requested search!", "Search Error", "")
            });
      }
      else
      {
        setShowLoading(false);
        //_mythis.showPopup("Internet unavailable. Please try again later!", "Warning", "");
      }
    // };
  }

  return (
    <IonPage>
      <IonHeader mode="ios">
        <HeaderApp pinValue={pinValue} recentValue={recentValue} history={history} location={location} match={match} isOnline={isOnline}></HeaderApp>
      </IonHeader>
      <IonContent fullscreen>
        {/* <IonHeader mode="ios" className="my-header-list">
        </IonHeader> */}
        <IonList mode="ios" className="my-ionlist">
          { harborIsVisible  && 
           ( <IonItem mode="ios" className="my-ion-item">
              <IonLabel mode="ios" position="stacked">Harbor</IonLabel>
              <IonSelect value={harbor} placeholder="Select Harbor" interface="action-sheet" 
                mode="ios" onIonChange={e => setHarbor(e.detail.value)}>
                  { Object.values(harbours).map((x:any) => {
                      return <IonSelectOption className="my-select-option" key={x.id} value={x.id}>{x.name}</IonSelectOption>
                })}  
              </IonSelect>
            </IonItem> )
          }
          <IonItem mode="ios" className="my-ion-item">
            <IonLabel mode="ios" position="stacked">Time Period</IonLabel>
            <IonSelect value={timePeriod} placeholder="Select Time Period" interface="action-sheet" mode="ios" 
                  onIonChange={e => setTimePeriod(e.detail.value)}>
              {Object.keys(EnumTimePeriods).filter((x:any) => !isNaN(Number(EnumTimePeriods[x])))
                  .map((x:any) => {
                    return <IonSelectOption key={EnumTimePeriods[x]} value={EnumTimePeriods[x]}>{x}</IonSelectOption>
              })}  
            </IonSelect>
          </IonItem>
          { timePeriod === 5 && 
            <>
              <IonItem className="my-ion-item" mode="ios">
                <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Start date</IonLabel>
                <IonIcon mode="ios" className="my-person-icon" slot="end" icon={calendarOutline} size="small"></IonIcon>
                <IonDatetime mode="ios" displayFormat={displayFormat}
                        pickerFormat={pickerFormat}
                        value={startDate}
                        onIonChange={e => startDateChange(e)}>
                </IonDatetime>
              </IonItem>
              <IonItem className="my-ion-item" mode="ios">
              <IonLabel mode="ios" className="my-ion-item-label" position="stacked">End date</IonLabel>
              <IonIcon mode="ios" className="my-person-icon" slot="end" icon={calendarOutline} size="small"></IonIcon>
              <IonDatetime mode="ios" displayFormat={displayFormat}
                      pickerFormat={pickerFormat}
                      value={endDate}
                      onIonChange={e => endDateChange(e)}>
              </IonDatetime>
            </IonItem>
           </>
          }
          <IonItem mode="ios" className="my-ion-item"> 
            <IonLabel mode="ios" position="stacked">Staff Person</IonLabel>
            <IonIcon mode="ios" className="my-person-icon" slot="end" icon={personOutline} onClick={pickUser} size="small"></IonIcon>
            <IonLabel mode="ios" className="my-person-label">{selectedUserName}</IonLabel>
          </IonItem>
          <IonItem mode="ios" className="my-ion-item">
            <IonLabel mode="ios" position="stacked">Activity Log Type</IonLabel>
            <IonSelect value={activityTypeId} placeholder="Select Activity Type" interface="action-sheet" mode="ios" 
                  onIonChange={e => setActivityTypeId(e.detail.value)}>
              {Object.keys(ActivityTypes).filter((x:any) => !isNaN(Number(ActivityTypes[x])))
                  .map((x:any) => {
                    return <IonSelectOption key={ActivityTypes[x]} value={ActivityTypes[x]}>{x}</IonSelectOption>
              })}  
            </IonSelect>
          </IonItem>
          <IonItem mode="ios" className="my-ion-item">
            <IonLabel mode="ios">On Watch List</IonLabel>
            <IonToggle mode="ios" checked={pinned} color="success" onIonChange={e => setPinned(e.detail.checked)} />
          </IonItem>
          <IonItem mode="ios" className="my-ion-item">
            <IonLabel mode="ios" position="stacked">Status</IonLabel>
            <IonSelect value={status} placeholder="Select Status" interface="action-sheet" mode="ios" 
                  onIonChange={e => setStatus(e.detail.value)}>
                  <IonSelectOption key={"-1"} value={"-1"}>All</IonSelectOption>  
                  <IonSelectOption key={"0"} value={"0"}>Closed</IonSelectOption>
                  <IonSelectOption key={"1"} value={"1"}>Open</IonSelectOption>
            </IonSelect>
            {/* <IonInput mode="ios" value={status} placeholder="Type value"></IonInput> */}
          </IonItem>
          <IonItem mode="ios" className="my-ion-item">
            <IonLabel mode="ios" position="stacked">Comments</IonLabel>
            <IonInput mode="ios" value={searchText} placeholder="Type value" onIonChange = {e => setSearchText(e.detail.value!)}></IonInput>
          </IonItem>
          <IonItem mode="ios" className="my-ion-item"> 
            <IonLabel mode="ios" position="stacked">Person</IonLabel>
            <IonIcon mode="ios" className="my-person-icon" slot="end" icon={personOutline} onClick={pickPerson} size="small"></IonIcon>
            <IonLabel mode="ios" className="my-person-label">{selectedPersonName}</IonLabel>
          </IonItem>
        </IonList>        
      </IonContent>
      <IonButton mode ="ios" class="my-main-button" onClick={search}>Search</IonButton>
      
      <IonModal mode="ios" isOpen={personSelectionVisibility} cssClass="my-modal-medium" backdropDismiss={false}>
        <IonList mode="ios">                
                    <IonItem mode="ios" className="my-ion-item">
                        <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Person</IonLabel>
                        <IonIcon mode="ios" className="my-person-close" slot="end" icon={closeOutline} onClick={closeSearchPerson} size="small"></IonIcon>
                        <IonInput mode="ios" value={searchPerson} placeholder="Search person" 
                                            onIonChange={e => setSearchPerson(e.detail.value!)}></IonInput>
                    </IonItem>
                    <IonRadioGroup>
                        {searchPersonList.map((x:any) => 
                            {
                                return  (
                                    <IonItem mode="ios" className="my-person-radio" key={x.Id}>
                                        <IonLabel mode="ios">{x.FullName}</IonLabel>
                                        <IonCheckbox mode="ios" slot="end" value={x.Id} checked = {personId === x.Id}
                                                    onIonChange={e => personSelect(e)} />
                                    </IonItem>
                                )
                            })
                        }
                    </IonRadioGroup>
                    {/* <IonButton mode="ios" class="my-main-button" onClick={closeSearchPerson}>Select</IonButton>  */}
          </IonList>
      </IonModal>

      <IonModal mode="ios" isOpen={userSelectionVisibility} cssClass="my-modal-medium" backdropDismiss={false}>
        <IonList mode="ios">                
                    <IonItem mode="ios" className="my-ion-item">
                        <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Staff Person</IonLabel>
                        <IonIcon mode="ios" className="my-person-close" slot="end" icon={closeOutline} onClick={closeSearchUser} size="small"></IonIcon>
                        <IonInput mode="ios" value={searchUser} placeholder="Search staff person" 
                                            onIonChange={e => setSearchUser(e.detail.value!)}></IonInput>
                    </IonItem>
                    <IonRadioGroup>
                        {searchUserList.map((x:any) => 
                            {
                                return  (
                                    <IonItem mode="ios" className="my-person-radio" key={x.Id}>
                                        <IonLabel mode="ios">{x.FullName}</IonLabel>
                                        <IonCheckbox mode="ios" slot="end" value={x.Id} checked = {userId === x.Id}
                                                    onIonChange={e => userSelect(e)} />
                                    </IonItem>
                                )
                            })
                        }
                    </IonRadioGroup>
                    {/* <IonButton mode="ios" class="my-main-button" onClick={closeSearchPerson}>Select</IonButton>  */}
          </IonList>
      </IonModal>

      <IonLoading mode="ios"
        cssClass='my-loading'
        isOpen={showLoading}
        onDidDismiss={() => setShowLoading(false)}
        message={'Searching...'}
      />

      <IonAlert mode="ios"
        isOpen={showMessage}
        onDidDismiss={() => setShowMessage(false)}
        cssClass='my-custom-class'
        header={'Alert'}
        subHeader={''}
        message={"The search didn't return results.<br/> Please, make another selection !"}
        buttons={['OK']}
      />    
      <IonAlert mode="ios"
        isOpen={showMessageAll}
        onDidDismiss={() => setShowMessageAll(false)}
        cssClass='my-custom-class'
        header={'Alert'}
        subHeader={''}
        message={"Please, make at least one selection different than All!"}
        buttons={['OK']}
      />    
    </IonPage>
  );
};

export default Search;
